import React from 'react';
import PropTypes from 'prop-types';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import { injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import messages from '../invoicingMessages';

const ToInvoiceGlobalActionsButton = props => {
  const { intl, disabled, onAddToInvoiceProposal } = props;

  return (
    <span
      className="tool-tip"
      data-toggle="tooltip"
      data-placement="top"
      title={disabled ? intl.formatMessage(messages.ToInvoiceGlobalActionsTooltip) : ''}
    >
      <DropdownButton
        bsSize="xsmall"
        bsStyle="default"
        className="btn-inverse"
        id="global-actions-button"
        disabled={disabled}
        pullRight
        title={intl.formatMessage(messages.GlobalActions)}
      >
        <MenuItem onSelect={onAddToInvoiceProposal} disabled={disabled}>
          {intl.formatMessage(messages.AddToInvoiceProposal)}
        </MenuItem>
      </DropdownButton>
    </span>
  );
};

ToInvoiceGlobalActionsButton.propTypes = {
  intl: intlShape.isRequired,
  disabled: PropTypes.bool,
  onAddToInvoiceProposal: PropTypes.func.isRequired,
};
ToInvoiceGlobalActionsButton.defaultProps = {
  disabled: false,
};
export default injectIntl(ToInvoiceGlobalActionsButton);
